{
	"name": "shapediver-app-builder",
	"version": "1.9.6",
	"private": true,
	"type": "module",
	"homepage": "./",
	"dependencies": {
		"@emotion/react": "11.14.0",
		"@iconify/react": "6.0.2",
		"@mantine/carousel": "8.3.14",
		"@mantine/charts": "8.3.14",
		"@mantine/core": "8.3.14",
		"@mantine/form": "8.3.14",
		"@mantine/hooks": "8.3.14",
		"@mantine/notifications": "8.3.14",
		"@plausible-analytics/tracker": "^0.4.5",
		"@sentry/react": "8.55.0",
		"@sentry/vite-plugin": "2.23.1",
		"@shapediver/sdk.geometry-api-sdk-v2": "3.4.2",
		"@shapediver/sdk.platform-api-sdk-v1": "2.29.16",
		"@shapediver/sdk.stargate-sdk-v1": "1.6.3",
		"@shapediver/viewer.features.attribute-visualization": "3.18.2",
		"@shapediver/viewer.features.drawing-tools": "3.18.2",
		"@shapediver/viewer.features.interaction": "3.18.2",
		"@shapediver/viewer.features.transformation-tools": "3.18.2",
		"@shapediver/viewer.session": "3.18.2",
		"@shapediver/viewer.shared.global-access-objects": "3.18.2",
		"@shapediver/viewer.shared.types": "3.18.2",
		"@shapediver/viewer.utils.mime-type": "1.1.0",
		"@shapediver/viewer.viewport": "3.18.2",
		"@tanstack/match-sorter-utils": "8.19.4",
		"@tanstack/react-table": "8.21.3",
		"@tanstack/react-virtual": "3.13.23",
		"gl-matrix": "3.4.4",
		"immer": "10.2.0",
		"langfuse": "3.38.6",
		"openai": "6.44.0",
		"post-robot": "8.0.32",
		"react": "19.2.4",
		"react-dom": "19.2.4",
		"react-infinite-scroll-hook": "5.0.2",
		"react-markdown": "9.1.0",
		"react-router-dom": "7.15.1",
		"remark-directive": "3.0.1",
		"remark-gfm": "4.0.1",
		"unist-util-visit": "5.1.0",
		"zod": "4.4.3",
		"zustand": "4.5.7"
	},
	"scripts": {
		"start": "vite",
		"postinstall": "playwright install chromium",
		"build": "tsc && vite build",
		"optimize": "tsc && vite optimize --force",
		"preview": "vite preview",
		"eslint": "eslint ./src ./*.ts ./cypress.config.ts ./tests ./typedoc",
		"eslint-fix": "eslint --fix ./src ./*.ts ./cypress.config.ts ./tests ./typedoc",
		"prettier": "prettier --write ./src/ ./*.ts ./*.html",
		"test": "jest --config jest.config.mjs",
		"test-e2e": "playwright test",
		"test-e2e-ui": "playwright test --ui",
		"test-e2e-update-snapshots": "playwright test --update-snapshots",
		"pick-coords": "tsx ./scripts/pick-coords.ts",
		"docs": "node --max-old-space-size=4096 ./node_modules/typedoc/bin/typedoc",
		"convert-slug-data": "tsx ./scripts/convertSlugData.ts",
		"build-appbuilder": "bash scripts/build-appbuilder.sh 0 v1/main",
		"build-appbuilder-platform": "bash scripts/build-appbuilder.sh 0 app/builder/v1/main",
		"publish-appbuilder": "bash scripts/build-appbuilder.sh 1 v1/main",
		"publish-appbuilder-platform": "bash scripts/build-appbuilder.sh 1 app/builder/v1/main",
		"publish": "bash scripts/build-appbuilder.sh 1",
		"generate:mantine-props-zod": "node scripts/generate-mantine-props-zod.mjs"
	},
	"browserslist": {
		"production": [
			">0.2%",
			"not dead",
			"not op_mini all"
		],
		"development": [
			"last 1 chrome version",
			"last 1 firefox version",
			"last 1 safari version"
		]
	},
	"devDependencies": {
		"@eslint/eslintrc": "^3.3.5",
		"@eslint/js": "^9.39.4",
		"@feature-sliced/eslint-config": "0.1.1",
		"@playwright/test": "^1.60.0",
		"@sentry/cli": "2.58.4",
		"@testing-library/jest-dom": "6.9.1",
		"@testing-library/react": "16.3.2",
		"@testing-library/user-event": "14.6.1",
		"@types/jest": "29.5.14",
		"@types/node": "22.19.11",
		"@types/post-robot": "10.0.6",
		"@types/react": "18.3.28",
		"@types/react-dom": "18.3.7",
		"@types/uuid": "10.0.0",
		"@typescript-eslint/eslint-plugin": "8.55.0",
		"@typescript-eslint/parser": "8.55.0",
		"@vitejs/plugin-react": "5.1.4",
		"dotenv": "17.2.3",
		"eslint": "^9.39.4",
		"eslint-config-prettier": "10.1.8",
		"eslint-import-resolver-typescript": "4.4.4",
		"eslint-plugin-boundaries": "5.4.0",
		"eslint-plugin-import": "2.32.0",
		"eslint-plugin-prettier": "5.5.5",
		"eslint-plugin-react": "7.37.5",
		"globals": "^17.6.0",
		"jest": "29.7.0",
		"jest-environment-jsdom": "29.7.0",
		"prettier": "3.8.1",
		"prettier-plugin-organize-imports": "4.3.0",
		"ts-jest": "29.4.6",
		"ts-to-zod": "^5.1.0",
		"tsx": "4.22.4",
		"typedoc": "^0.28.13",
		"typedoc-plugin-markdown": "^4.9.0",
		"typescript": "5.9.3",
		"typescript-eslint": "^8.61.1",
		"vite": "8.0.16",
		"vite-bundle-analyzer": "1.3.8",
		"vite-plugin-svgr": "5.2.0",
		"web-vitals": "4.2.4"
	},
	"lint-staged": {
		"*.{js,json,yml,yaml,css,scss,ts,tsx,md}": [
			"prettier --write"
		]
	}
}
